import {
  endOfMonth,
  endOfToday,
  endOfYear,
  startOfMonth,
  startOfYear,
  subDays,
  subMonths,
  subYears,
} from "date-fns";
import { DateRange } from "./types";
import { removeTimezoneOffsetIfNeeded } from "@common/components/utils";

export enum PresetDateRange {
  Last30Days = "Last 30 Days",
  ThisMonth = "This Month",
  LastMonth = "Last Month",
  Last3Months = "Last 3 Months",
  Last6Months = "Last 6 Months",
  Last12Months = "Last 12 Months",
  Last90Days = "Last 90 Days",
  YearToDate = "Year to Date",
  PreviousYear = "Previous Year",
  // CustomRange = "Custom Range",
}

const today = endOfToday();

export const presets: Record<PresetDateRange, DateRange> = {
  [PresetDateRange.Last30Days]: {
    startDate: subDays(today, 30),
    endDate: today,
  },
  [PresetDateRange.ThisMonth]: {
    startDate: startOfMonth(today),
    endDate: removeTimezoneOffsetIfNeeded(endOfMonth(today)),
  },
  [PresetDateRange.LastMonth]: {
    startDate: startOfMonth(subMonths(today, 1)),
    endDate: removeTimezoneOffsetIfNeeded(endOfMonth(subMonths(today, 1))),
  },
  [PresetDateRange.Last3Months]: {
    startDate: startOfMonth(subMonths(today, 2)),
    endDate: removeTimezoneOffsetIfNeeded(endOfMonth(today)),
  },
  [PresetDateRange.Last6Months]: {
    startDate: startOfMonth(subMonths(today, 5)),
    endDate: removeTimezoneOffsetIfNeeded(endOfMonth(today)),
  },
  [PresetDateRange.Last12Months]: {
    startDate: startOfMonth(subMonths(today, 12)),
    endDate: removeTimezoneOffsetIfNeeded(endOfMonth(today)),
  },
  [PresetDateRange.Last90Days]: {
    startDate: subDays(today, 90),
    endDate: removeTimezoneOffsetIfNeeded(today),
  },
  [PresetDateRange.YearToDate]: {
    startDate: startOfYear(today),
    endDate: removeTimezoneOffsetIfNeeded(today),
  },
  [PresetDateRange.PreviousYear]: {
    startDate: startOfYear(subYears(today, 1)),
    endDate: removeTimezoneOffsetIfNeeded(endOfYear(subYears(today, 1))),
  },
  // [PresetDateRange.CustomRange]: {
  //   startDate: today,
  //   endDate: today,
  // },
};

export const DEFAULT_DATE_RANGE = presets[PresetDateRange.Last30Days];
